/**
 * School Popup Content
 * 
 * @Author: Focci
 * @Date: 2023-07-17 16:07:44
 * @Last Modified by: Focci
 * @Last Modified time: 2023-07-17 16:07:44
 */

import PropTypes from 'prop-types'
import useFetch from '@hook/useFetch'
import { useMemo, useState } from 'react'
import { Boundary } from '@comp/mapbox'
import { PopupCardSkeleton, SchoolCard } from './PropertyCards'
import { CircleBoundary } from '../Boundary'

export default function SchoolPopupContent({
  schoolId = null,
  events,
}) {
  const { data, isLoading } = useFetch(`school/${schoolId}`)
  const [displayBoundary, setDiaplayBoundary] = useState(true)

  const switchProps = useMemo(() => ({
    checked: displayBoundary,
    color: '#ff8500',
    onChange: (e) => setDiaplayBoundary(e.target.checked),
  }), [displayBoundary])
  
  if(isLoading) {
    return (
      <PopupCardSkeleton showCover={false} />
    )
  }

  return (
    <>
      <SchoolCard data={data} switchProps={switchProps} events={events} />
      {displayBoundary && (
        data?.has_school_network > 0 
          ? (
            <Boundary
              data={data?.coordinates}
              borderColor="#ff8500"
              needFill
              color="#ff8500"
            />
          )
          : <CircleBoundary center={[data.lng, data.lat]} />
      )}
    </>
  )
}

SchoolPopupContent.propTypes = {
  schoolId: PropTypes.number,
}
